import { useCreateState } from '../../../../hooks/useCreateState';
import { Dependency } from '@modules/Dependencies/api/models/dependency.model';
import localStorageManager from './utils/localStorageManager';

const storage = localStorageManager('zde-deps-navigation');

export enum OpenStatusEnum {
  INITIAL_HIDE = 'initialHide',
  MANUAL_HIDE = 'manualHide',
  OPEN = 'open'
}

export const initialState = {
  isActive: false,

  openStatus: OpenStatusEnum.INITIAL_HIDE as OpenStatusEnum,

  shouldAnimateClosedComponent: true,

  currentEntityNameAndType: {
    Name: null,
    DisplayName: null,
    EntityType: null,
    Version: 0,
    Revision: 0,
    DataSource: null,
    RefType: 'Parent'
  } as Dependency,
  recentOpened: storage.getItem() || [],
  dependencies: {
    error: [] as Dependency[],
    correct: [] as Dependency[],
    usedIn: [] as Dependency[],
    uses: [] as Dependency[]
  }
};

export default function useAppState() {
  return useCreateState({
    initialState,
    reducers: {
      activateNavigation: (state, action: { payload: boolean }) => ({
        ...state,
        isActive: action.payload
      }),
      setCurrentEntityNameAndType: (state, action: { payload: Partial<Dependency> }) => ({
        ...state,
        currentEntityNameAndType: { ...state.currentEntityNameAndType, ...action.payload }
      }),
      open: (state, action: { payload: OpenStatusEnum }) => ({
        ...state,
        openStatus: action.payload,
        shouldAnimateClosedComponent: false
      }),
      setAllDependencies: (state, action: { payload: { data: Dependency[], metadata: any } }) => {
        const allDependencies = action.payload.data;
        let displayName = null;

        if (!allDependencies) {
          return { ...state, dependencies: { error: [], correct: [], usedIn: [], uses: [] } };
        }

        if (state.currentEntityNameAndType.EntityType === 'Signal' || state.currentEntityNameAndType.EntityType === 'Component') {
          const componentList = action.payload.metadata['componentList']
          const relatedComponent = componentList.find((component: any) => component.Name === state.currentEntityNameAndType.Name);
          displayName = relatedComponent.DisplayName;
        }

        const withErrorDependencies = allDependencies.filter(o => o.RefType === 'Error');
        const correctDependencies = allDependencies.filter(o => o.RefType !== 'Error');
        const usedIn = correctDependencies.filter(o => o.RefType === 'Used');
        const uses = correctDependencies.filter(o => o.RefType !== 'Used');

        const currentEntityNameAndType = {
          ...state.currentEntityNameAndType,
          DisplayName: displayName
        }

        const dependencies = {
          correct: [ ...usedIn, currentEntityNameAndType, ...uses ],
          error: withErrorDependencies,
          usedIn: usedIn,
          uses: uses
        };

        return {
          ...state,
          dependencies,
          currentEntityNameAndType: currentEntityNameAndType
        };
      },
      addRecentOpened: (state) => {
        let res = storage.getItem() || [];

        const isDuplicated = res.find((saved: Dependency) => (
          saved.Name === state.currentEntityNameAndType.Name && saved.EntityType === state.currentEntityNameAndType.EntityType
        ));

        if (!isDuplicated) {
          if (res && res.length === 3) {
            const tmp = res.slice(1);
            res = [...tmp, state.currentEntityNameAndType];
          } else {
            res.push(state.currentEntityNameAndType);
          }
        }

        storage.setItem(res);

        return {
          ...state,
          recentOpened: res
        };
      }
    }
  });
}
